if(typeof require !== 'undefined'){
	var $ = (typeof window.$ === 'function') ? window.$ : require('jquery');
}

function SystemsightFormConditions(options) {
	var defaults = {
		version: '1.0.2',
		conditionalSelector: '.conditional-fields',
	};
	var that = this;
	options = options || {};

	that.options = $.extend(true, {}, defaults, options);
	that.init();
}
SystemsightFormConditions.prototype.init = function () {
	var that = this;
	console.info('SystemsightFormConditions loaded (' + that.options.version + ')');
	that.searchFieldGroups();
};
SystemsightFormConditions.prototype.searchFieldGroups = function () {
	var that = this;
	$(that.options.conditionalSelector).each(function () {
		if($(this).data('conditions-inited')) return;
		that.initFieldsGroup($(this));
	});
};
SystemsightFormConditions.prototype.initFieldsGroup = function ($fieldsGroup) {
	var that = this;
	$fieldsGroup.on('change', ':input', function (e) {
		that.checkInputs($fieldsGroup);
	});

	$fieldsGroup.find('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		that.checkInputs($fieldsGroup);
	})

	$fieldsGroup.removeClass('d-none');

	that.checkInputs($fieldsGroup);

	console.info('SystemsightFormConditions init for: ', $fieldsGroup[0]);
	$fieldsGroup.data('conditions-inited', true);
};
SystemsightFormConditions.prototype.checkInputs = function ($fieldsGroup) {
	var that = this;
	var prefix = $fieldsGroup.data('prefix');
	var options = $fieldsGroup.data('options') || {};

	$fieldsGroup.find('.form-group, .form-tab, .conditional-field').each(function (e) {
		var $inputGroup = $(this);



		var conditionals = $(this).data('conditionals');
		if(conditionals){

			var $container = $inputGroup.closest('.tab-pane');
			//jei laukas yra konteineryje, kuris yra nematomas, tai nieko nedarom
			if($container.length > 0 && $container.is(':visible') === false) return;

			var showCondition = true;
			var enableCondition = true;
			for (var k in conditionals){
				var conditional = conditionals[k];

				if(typeof conditional.show === 'boolean'){
					var show = conditional.show;
					showCondition = showCondition && (that.getFieldCondition($fieldsGroup, conditional, show) === show);
				}
				else if(typeof conditional.enable === 'boolean'){
					var enable = conditional.enable;
					enableCondition = enableCondition && (that.getFieldCondition($fieldsGroup, conditional, enable) === enable);
				}
			}
			that.toggleInput($inputGroup, showCondition, enableCondition);
		}
	});
	if(options.onChecked){
		that.callCallback(options.onChecked, options.nonce);
	}
};
SystemsightFormConditions.prototype.getFieldCondition = function($fieldsGroup, conditional, show){
	var that = this;

	if(typeof conditional.or === "object"){
		var or = false;
		for (var ck in conditional.or){
			var orConditional = conditional.or[ck];
			or = or || that.getFieldCondition($fieldsGroup, orConditional, show);
		}
		return or;
	}else if(typeof conditional.when != "undefined"){
		var prefix = $fieldsGroup.data('prefix');
		var whenInputName = prefix?prefix + "[" + conditional.when + "]" : conditional.when;
		var $whenField = $fieldsGroup.find(":input[name='"+whenInputName+"']");

		$whenField = that.filterInputs($whenField);

		if($whenField.length && $whenField.is(":visible")){
			if(conditional.eq !== undefined){
				switch (typeof conditional.eq) {
					case "boolean":
						return $whenField[0].checked == conditional.eq;
					case "string":
						//if when field is multiple select
						if (typeof $whenField.val() == "object") {
							return $.inArray(conditional.eq, $whenField.val()) > -1;
						} else {
							return $whenField.val() === conditional.eq;
						}
					case "number":
						return $whenField.val() === conditional.eq.toString()
					case "object":
						return $.inArray($whenField.val(), conditional.eq) > -1;
				}
			}else if(conditional.gt !== undefined){
				switch (typeof conditional.gt) {
					case "string":
					case "number":
						return $whenField.val() > conditional.gt;
				}
			}else if(conditional.lt !== undefined){
				switch (typeof conditional.lt) {
					case "string":
					case "number":
						return $whenField.val() < conditional.lt;
				}
			}else if(conditional.gte !== undefined){
				switch (typeof conditional.gte) {
					case "string":
					case "number":
						return $whenField.val() >= conditional.gte;
				}
			}else if(conditional.lte !== undefined){
				switch (typeof conditional.lte) {
					case "string":
					case "number":
						return $whenField.val() <= conditional.lte;
				}
			}
		}else{
			return !show;
		}
	}
	return show;
};
SystemsightFormConditions.prototype.filterInputs = function($whenField){
	var fieldType = $whenField.attr('type');

	if(fieldType === 'radio'){
		$whenField = $whenField.filter(':checked');
	}

	return $whenField;
}

SystemsightFormConditions.prototype.callCallback = function(callback, nonce){
	var that = this;
	if(typeof callback == "string"){
		var $script = $('<script nonce="' + nonce + '">' + callback + '</script>')
		$('body').append($script)
		$script.remove();
	}else{
		callback();
	}
};
SystemsightFormConditions.prototype.toggleInput = function($inputOrGroup, show, enable, $parent){
	var that = this;
	if($inputOrGroup.is(':input')){
		if(show){
			$inputOrGroup.attr('disabled', null);

			if(enable){
				$inputOrGroup.attr('disabled', null);
			}else{
				$inputOrGroup.attr('disabled', 'disabled');
			}

		}else{
			$inputOrGroup.attr('disabled', 'disabled');
		}
	}else{
		$inputOrGroup.find(':input').each(function () {
			that.toggleInput($(this), show, enable, $inputOrGroup);
		})
	}

	if(typeof $parent === 'undefined'){
		if(show){
			$inputOrGroup.removeClass('d-none')
		}else{
			$inputOrGroup.addClass('d-none')
		}
	}

};


if (typeof module === "object" && typeof module.exports === "object"){
	//node modules support
	module.exports = new SystemsightFormConditions();
}else{
	var systemsightFormConditions;
	$(document).ready(function () {
		systemsightFormConditions = new SystemsightFormConditions();
	});
}


